import(/* webpackMode: "eager", webpackExports: ["HallOfFameContent"] */ "/opt/build/repo/src/app/(site)/halloffame/components/content.tsx");
